'use strict';

// Vue
import Vue from 'vue';
import router from 'router';

// API
import {
  requestScheduleAppointment,
  requestCancelAppointment,
  requestAppointmentUpcoming,
  requestAppointmentF2fUpcoming,
  requestFinalizeAppointment,
  requestVideoUrl,
  createF2fAppointment,
  updateF2fAppointment,
  requestAppointmentQuery,
  requestRetrievePatient,
  requestPatientDocumentList,
  requestPatientDocument,
} from 'api/appointment';

import store from 'store';

import moment from 'moment';

// Utils

// data() {
//   return {
//       org: {
//           phone: '123-456-7890', // replace with your dynamic phone number
//       },
//   };
// }

// Models
import states from 'models/contact/states';
import { reject } from 'lodash';


// State
const state = {
  appointments: [],
  patient: [],
  patientFname:'',
};

// Getters
const getters = {
  appointmentData: state => state.appointmentData,
  appointments: state => state.appointments,
  f2fAppointment: state => state.f2fAppointment,
  video: state => state.video,
  tempAppointmentData: state => state.tempAppointmentData,
  savingAppointmentAnswer: state => state.savingAppointmentAnswer,
  queryData: state => state.queryData,
  patient: state => state.patient,
  documents: state => state.documents,
  patientFname: state=> state.patientFname,
};

// Mutations
const mutations = {
  SAVE_APPOINTMENT(state, payload) {
    Vue.set(state, 'appointments', payload);
    localStorage.setItem('upcomingAppts', JSON.stringify(payload));
  },

  SAVE_F2F_APPOINTMENT(state, payload) {
    Vue.set(state, 'f2fAppointment', payload);
  },

  SAVE_VIDEO_URL(state, payload) {
    Vue.set(state, 'video', payload);
  },

  SAVE_APPOINTMENT_DATA(state, payload) {
    Vue.set(state, 'appointmentData', payload);
  },

  SAVE_TEMP_APPOINTMENT_DATA(state, payload) {
    Vue.set(state, 'tempAppointmentData', payload);
  },

  SET_SAVING_ANSWER_STATE(state, payload) {
    Vue.set(state, 'savingAppointmentAnswer', payload);
  },

  SAVE_QUERY_DATA(state, payload) {
    Vue.set(state, 'queryData', payload);
  },

  SAVE_PATIENT(state, payload) {
    Vue.set(state, 'patient', payload);
  },

  SAVE_FIRSTNAME(state, payload) {
    Vue.set(state, 'patientFname', payload);
  },

  SAVE_DOCUMENTS(state, payload) {
    Vue.set(state, 'documents', payload);
  },
};



// Actions
const actions = {
  requestAppointmentUpcoming({ commit }) {
    return new Promise((resolve, reject) => {
      let storedUser = {
        md_live: {
          user: {},
        },
      };

      storedUser = JSON.parse(localStorage.getItem('updateUser'));

      const model = {
        id: '',
        token: '',
      };

      if (storedUser) {
        model.id = storedUser.mdlive_id;
        model.token = storedUser.md_live.jwt;

        requestAppointmentUpcoming(model)
          .then(res => {
            commit('SAVE_APPOINTMENT', res.data.appointments);
          })
          .catch(error => {
            console.error(error);
            store.dispatch('auth/requestLogout'); 
            reject(error);
          });
      }
    });
  },

  requestAppointmentF2fUpcoming({ commit }) {
    commit('auth/SET_HEADERS', 'fueled', { root: true });

    return new Promise((resolve, reject) => {
      requestAppointmentF2fUpcoming()
        .then(response => {
          if (response.data.appointment_method === 'face_to_face') {
            commit('SAVE_F2F_APPOINTMENT', response.data);
            resolve(response);
          }
        })
        .catch(error => {
          console.error(error);
          store.dispatch('auth/requestLogout');            
          reject(error);
        });
    });
  },

  async requestScheduleAppointment({ commit, dispatch, rootGetters, state }, payload) {
    // Handle F2F booking

    if ( !rootGetters['questions/f2fSelected'] ) {
      commit('auth/SET_HEADERS', 'mdLive', { root: true });
    }

    if ( rootGetters['questions/f2fSelected'] ) {
      commit('auth/SET_HEADERS', 'fueled', { root: true });
      const response = await requestFinalizeAppointment(localStorage.getItem('appointmentSelectionAnswer'));

      if ( response.status === 200 ) {
        _.forEach(_.filter(Object.keys(localStorage), key => key.split('_').shift() === 'q'), questionnaire => { // eslint-disable-line no-undef
          localStorage.removeItem(questionnaire);
        });

        localStorage.removeItem('appointmentSelectionAnswer');

        router.push({
          name: 'register-success',
        });
      }

      return;
    }

    // Handle telehealth booking
    let user;
    if ( localStorage.getItem('updateUser') ) {
      user = JSON.parse(localStorage.getItem('updateUser'));
    }

    if (
      localStorage.getItem('mdLiveAuthToken') &&
      rootGetters['auth/activeHeader'] !== 'mdLive' ) {

      commit('auth/SET_HEADERS', 'mdLive', { root: true });
    }

    let chiefComplaint;
    if ( rootGetters['answers/allQuestions'].length && !user ) {
      if ( localStorage.getItem('answerComplaint') && localStorage.getItem('answerSecondaryComplaint') ) {
        chiefComplaint = `${localStorage.getItem('answerComplaint')}, ${localStorage.getItem('answerSecondaryComplaint')}`;
      } else {
        chiefComplaint = localStorage.getItem('answerComplaint');
      }
    } else {
      chiefComplaint = user.chief_complaint1 ? user.chief_complaint1 : null;
    }

    let stateAbbrev;
    if ( rootGetters['answers/allQuestions'].length && !user ) {
      stateAbbrev = _.find(states, state => state.label === localStorage.getItem('answerLocation')).value; // eslint-disable-line no-undef
    } else if (localStorage.getItem('tempState')) {
      stateAbbrev = localStorage.getItem('tempState');
    } else {
      stateAbbrev = user.appointment_state;
    }

    const data = {
      config: {
        appointment: {
          provider_id: rootGetters['provider/provider'].id,
          appointment_method: rootGetters['provider/selectedAppointmentType'],
          consent_user_initials: payload && payload.mdlive_consent_user_initials || null,
          customer_call_in_number: payload && payload.phone || user.phone,
          provider_type_id: rootGetters['app/org'].mdlive_provider_type, // TODO: Var?
          start_time: moment(rootGetters['provider/selectedSlot'].timeslot).unix(),
          state_abbrev: stateAbbrev,
          survey_answer: chiefComplaint,
          chief_complaint: chiefComplaint,
          agrees_to_informed_consent: payload && payload.agrees_to_mdlive_informed_consent || null,
          agrees_to_privacy_agreement: payload && payload.agrees_to_mdlive_privacy_agreement || null,
        },
      },
      id: payload && payload.patientId || user.mdlive_id,
    };

    // Means we're having a retry
    if (state.tempAppointmentData) {
      data.config.appointment.consent_user_initials = state.tempAppointmentData.mdlive_consent_user_initials;
      data.config.appointment.agrees_to_informed_consent = state.tempAppointmentData.agrees_to_mdlive_informed_consent;
      data.config.appointment.agrees_to_privacy_agreement = state.tempAppointmentData.agrees_to_mdlive_privacy_agreement;
    }

    const newUser = (payload && payload.newUser) || (state.tempAppointmentData && state.tempAppointmentData.newUser) || false;

    if (localStorage.getItem('rescheduling')) {
      const currentAppointment = {
        id: localStorage.getItem('rescheduleId'),
        patient: data.id,
      };

      return requestCancelAppointment(currentAppointment)
        .then(() => {
          requestScheduleAppointment(data)
            .then(() => {
              router.push({
                name: 'register-success',
              });
            })
            .catch(error => {
              if (error && error.data.error_codes && error.data.error_codes.length) {
                router.push({
                  name: 'error',
                });
              }
              reject(error);
            });
        });
    }

    return new Promise((resolve, reject) => {
    
      requestScheduleAppointment(data)
        .then(response => {
          commit('SAVE_APPOINTMENT_DATA', response.data);

          if (newUser) {
            const question = localStorage.getItem('q_intakeDetailLastQuestion');
            const answers = JSON.parse(localStorage.getItem('q_intakeDetail'));
            const buildAnswer = Object.keys(answers)
              .filter((key) => key.includes(question))
              .reduce((cur, key) => answers[key], {});

            const intake = {
              question,
              answer: buildAnswer,
            };

            commit('auth/SET_HEADERS', 'fueled', { root: true });

            createF2fAppointment(intake)
              .then((response) => {
                requestFinalizeAppointment(response.data.id)
                  .then(() => {
                    router.push({
                      name: 'register-verification',
                    });
                  });
              })
              .catch((err) => console.log(err));
          }

          if ( user && !newUser ) {
            if (localStorage.getItem('tempState')) localStorage.removeItem('tempState');
            router.push({
              name: 'register-success',
            });
          }

          if (state.tempAppointmentData && newUser) {
            router.push({
              name: 'register-verification',
            });
          }

          // Empty temp data so it can be used in the next round if needed
          commit('SAVE_TEMP_APPOINTMENT_DATA', null);

          resolve(response);
        })
        .catch(error => {
          if (error && error.data.error_codes && error.data.error_codes.length) {
            if (error.data.error_codes[0] === 'provider_unavailable') {
              dispatch('app/setErrorMessage', 'You are successfully registered but the appointment couldn\'t be finalized due to some time conflict. Please choose another available time.', { root: true });
              dispatch('app/setErrorRedirect', { link: 'provider-schedule', label: 'Select another time' }, { root: true });

              commit('SAVE_TEMP_APPOINTMENT_DATA', payload);

              router.push({
                name: 'error',
              });
            }
            if (error.data.error_codes[0] === 'no_eap_sessions_remaining') {

              dispatch('app/setErrorMessage', 'You have used the allotted number of EAP sessions listed on your authorization, or your authorization has expired. Please contact us 24/7 if you would like to request additional EAP sessions.', { root: true });

              router.push({
                name: 'mdlerror',
              });
            }

            if (error.data.error_codes[0] === 'not_allowed_for_patient' || error.data.error_codes[0] === 'provider_unavailable' || error.data.error_codes[0] === 'no_state_license') {
              dispatch('app/setErrorMessage', 'Sorry, we were unable to schedule an appointment with this counselor. Please contact us 24/7 for assistance with scheduling.', { root: true });

              router.push({
                name: 'mdlerror',
              });
            }

          }

          reject(error);
        });
    });
  },

  async requestCancelAppointment({ commit }, model) {
    if (localStorage.getItem('mdLiveAuthToken')) {
      commit('auth/SET_HEADERS', 'mdLive', { root: true });
    }

    const response = await requestCancelAppointment(model);

    commit('SAVE_APPOINTMENT_DATA', '');
    commit('/provider/SAVE_PROVIDER_DETAILS', '');

    return response;
  },

  requestRetrievePatient({ commit }) {
    if (localStorage.getItem('mdLiveAuthToken')) {
      commit('auth/SET_HEADERS', 'mdLive', { root: true });
    }

    const id = JSON.parse(localStorage.getItem('updateUser')).mdlive_id;


    return new Promise((resolve, reject) => {
      requestRetrievePatient(id)
        .then((response) => {
          commit('SAVE_PATIENT', response.data.patient_profile.completed_appointments);
          commit('SAVE_FIRSTNAME', response.data.patient_profile.first_name);
          return response;
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  },

  async requestPatientDocumentList({ commit }, model) {
    if (localStorage.getItem('mdLiveAuthToken')) {
      commit('auth/SET_HEADERS', 'mdLive', { root: true });
    }

    const response = await requestPatientDocumentList(model);

    commit('SAVE_DOCUMENTS', response && response.data.documents);

    return response;
  },

  async requestPatientDocument({ commit }, model) {
    if (localStorage.getItem('mdLiveAuthToken')) {
      commit('auth/SET_HEADERS', 'mdLive', { root: true });
    }

    const response = await requestPatientDocument(model);
    return response;
  },

  requestAppointmentQuery({ commit, rootGetters, dispatch }, model) {

    commit('auth/SET_HEADERS', 'fueled', { root: true });

    const user = localStorage.getItem('updateUser') ? JSON.parse(localStorage.getItem('updateUser')) : null;
    const newUser = localStorage.getItem('newUser');

    const { appointment_date, ...modelWithout } = model; // eslint-disable-line no-unused-vars

    const data = {
      provider_id: rootGetters['provider/provider'].id,
      appointment_date: moment(model.appointment_date).format('YYYY-MM-DD'),
      provider_type_id: rootGetters['app/org'].mdlive_provider_type,
      ...modelWithout,
    };

    if (!user) {
      commit('SAVE_QUERY_DATA', data);
      localStorage.setItem('newUser', true);
      router.push({
        name: 'register',
      });
    }
    else {
      return new Promise((resolve, reject) => {
        requestAppointmentQuery(data)
          .then(response => {
            commit('SAVE_QUERY_DATA', data);
            if (user && !newUser) {
              router.push({
                name: 'register-success',
              });
            }

            else if (state.queryData && !user) {
              router.push({
                name: 'register-verification',
              });
            }
            resolve(response.data);
          })
          .catch(error => {
            if (error.data.errors[0].message.includes('no_eap_sessions_remaining')) {

              dispatch('app/setErrorMessage', 'You have used the allotted number of EAP sessions listed on your authorization, or your authorization has expired. Please contact us 24/7 if you would like to request additional EAP sessions.', { root: true });

              router.push({
                name: 'mdlerror',
              });
            }
            if (error.data.errors[0].message.includes('not_found')) {

              dispatch('app/setErrorMessage', 'Sorry, we were unable to schedule this appointment for you. Please contact us 24/7 for assistance with scheduling.', { root: true });

              router.push({
                name: 'mdlerror',
              });
            }

            console.error(error);
            reject(error);
          });
      });
    }

  },

  requestVideoUrl({ commit }, id) {
    if ( localStorage.getItem('mdLiveAuthToken') ) {
      commit('auth/SET_HEADERS', 'mdLive', { root: true });
    }
    return new Promise((resolve, reject) => {
      requestVideoUrl(id)
        .then(response => {
          commit('SAVE_VIDEO_URL', response.data);
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  },

  createF2fAppointment(context, target) {
    return new Promise((resolve, reject) => {
      createF2fAppointment(target.model)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  },

  updateF2fAppointment({ commit }, target) {
    commit('SET_SAVING_ANSWER_STATE', true);

    return new Promise((resolve, reject) => {
      updateF2fAppointment(target.id, target.model)
        .then(response => {
          commit('SET_SAVING_ANSWER_STATE', false);
          resolve(response);
        })
        .catch(error => {
          console.error(error);
          commit('SET_SAVING_ANSWER_STATE', false);
          reject(error);
        });
    });
  },
};




export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./client/store/appointment.js